import React from 'react';

const Pill = ({ label, color }) => (
  <span className={`pill pill--${color}`}>{label}</span>
);

export default Pill;
